import { Injectable, inject } from '@angular/core';
import { HubConnection } from '@microsoft/signalr';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { SignalHubService } from './signal-hub.service';

@Injectable({
    providedIn: 'root',
})
export class InvokeSignalService {
    private signalServer = inject(SignalHubService);


    private _newNotification$: BehaviorSubject<any> = new BehaviorSubject<any>({});
    public get newNotification$() {
        return this._newNotification$.asObservable().pipe(filter(x => x != undefined));
    }
    private receiverAsyncFeed$: BehaviorSubject<any> = new BehaviorSubject<any>({});
    private receiverAsyncMessage$: BehaviorSubject<any> = new BehaviorSubject<any>({});
    private subscribtionMessage = this.receiverAsyncMessage$.asObservable();

    constructor() {
        this.connect();
    }

    private receiveNotification(connection: HubConnection) {
        if (this.signalServer.IsConnected) {
            connection.on("SendToUser", (userId, data) => {
                this._newNotification$.next({ userId, data });
            });
        }
        else {
            this.signalServer.startConnection();
        }
    }

    private connect() {
        this.signalServer.Connection.subscribe((connection) => {
            if (connection) {
                this.receiveFeed(connection);
                this.receiveNotification(connection);
            }
        });
    }

    private receiveFeed(connection: HubConnection) {
        if (this.signalServer.IsConnected) {
            connection.on("SendFeedsToUser", (userId, data) => {
                this.receiverAsyncFeed$.next({ userId, data });
            });
        }

    }

    public getFeeds(): Observable<any> {
        return this.receiverAsyncFeed$.asObservable().pipe(filter(x => x != undefined));;
    }

    public getMessages(): Observable<any> {
        return this.subscribtionMessage.pipe(
            filter(x => x != undefined),
        );
    }

}